namespace Nobox.CRM {
    export interface GroupsForm {
        Name: Serenity.StringEditor;
        OwnerId: Serenity.ServiceLookupEditor;
        Image: Serenity.ImageUploadEditor;
        Web: Serenity.StringEditor;
        Telephone: Serenity.StringEditor;
        Address: Serenity.StringEditor;
        Latitude: Serenity.StringEditor;
        Longitude: Serenity.StringEditor;
        Country: Serenity.ServiceLookupEditor;
        State: StateNmLookupEditor;
        City: CityNmLookupEditor;
        ZipCode: Serenity.StringEditor;
        Industry: IndustryEditor;
        Type: GroupTypeEditor;
        Source: GroupSourceEditor;
        Grp: Serenity.ServiceLookupEditor;
        In: CustomDateTimeEditor;
        Up: CustomDateTimeEditor;
        InBy: Serenity.ServiceLookupEditor;
        UpBy: Serenity.ServiceLookupEditor;
    }

    export class GroupsForm extends Serenity.PrefixedContext {
        static formKey = 'Nobox.Groups';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!GroupsForm.init)  {
                GroupsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.ServiceLookupEditor;
                var w2 = s.ImageUploadEditor;
                var w3 = StateNmLookupEditor;
                var w4 = CityNmLookupEditor;
                var w5 = IndustryEditor;
                var w6 = GroupTypeEditor;
                var w7 = GroupSourceEditor;
                var w8 = CustomDateTimeEditor;

                Q.initFormType(GroupsForm, [
                    'Name', w0,
                    'OwnerId', w1,
                    'Image', w2,
                    'Web', w0,
                    'Telephone', w0,
                    'Address', w0,
                    'Latitude', w0,
                    'Longitude', w0,
                    'Country', w1,
                    'State', w3,
                    'City', w4,
                    'ZipCode', w0,
                    'Industry', w5,
                    'Type', w6,
                    'Source', w7,
                    'Grp', w1,
                    'In', w8,
                    'Up', w8,
                    'InBy', w1,
                    'UpBy', w1
                ]);
            }
        }
    }
}
